import { render, staticRenderFns } from "./sku-table.vue?vue&type=template&id=58a296e7&"
import script from "./sku-table.vue?vue&type=script&lang=js&"
export * from "./sku-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports